import { render, staticRenderFns } from "./AnnotationMenu.vue?vue&type=template&id=0f3afea7&"
import script from "./AnnotationMenu.vue?vue&type=script&lang=js&"
export * from "./AnnotationMenu.vue?vue&type=script&lang=js&"
import style0 from "./AnnotationMenu.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../code/tibava/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports